import { render } from "./SetUp.vue?vue&type=template&id=4178cd0e&scoped=true"
import script from "./SetUp.vue?vue&type=script&lang=js"
export * from "./SetUp.vue?vue&type=script&lang=js"

import "./SetUp.vue?vue&type=style&index=0&id=4178cd0e&scoped=true&lang=css"

import exportComponent from "/Users/binyu/fe/eshop-vant4-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4178cd0e"]])

export default __exports__